import { render, staticRenderFns } from "./uis-auth.vue?vue&type=template&id=7c114439&scoped=true&"
import script from "./uis-auth.vue?vue&type=script&lang=js&"
export * from "./uis-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c114439",
  null
  
)

export default component.exports